<ion-col class="flex-align-center">
    <ion-grid>
        <ion-row>
            <ion-col size="12" class="ion-text-center">
                <h3>Templates de Email</h3>
            </ion-col>
        </ion-row>

        <ion-row *ngFor="let item of config?.ConfigList">

            <ion-col class="flex-align-center">
                <ion-grid>
                    <!-- Novo Feedback -->
                    <ion-row class="email-template-section">
                        <ion-col size="12">
                            <ion-card>
                                <ion-card-header>
                                    <ion-card-title>Novo Feedback</ion-card-title>
                                </ion-card-header>
                                <ion-card-content>
                                    <ion-row>
                                        <ion-col size="12"><strong>Assunto:</strong></ion-col>
                                        <ion-col size="12">{{ item?.NewFeedback_Subject }}</ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col size="12"><strong>Corpo:</strong></ion-col>
                                        <ion-col size="12">
                                            <div class="email-body" [innerHTML]="item?.NewFeedback_Body"></div>
                                        </ion-col>
                                    </ion-row>
                                </ion-card-content>
                            </ion-card>
                        </ion-col>
                    </ion-row>

                    <!-- Cópia de Submissão de Comerciante -->
                    <ion-row class="email-template-section">
                        <ion-col size="12">
                            <ion-card>
                                <ion-card-header>
                                    <ion-card-title>Cópia de Submissão de Comerciante</ion-card-title>
                                </ion-card-header>
                                <ion-card-content>
                                    <ion-row>
                                        <ion-col size="12"><strong>Assunto:</strong></ion-col>
                                        <ion-col size="12">{{ item?.MerchantApplicationCopy_Subject
                                            }}</ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col size="12"><strong>Corpo:</strong></ion-col>
                                        <ion-col size="12">
                                            <div class="email-body" [innerHTML]="item?.MerchantApplicationCopy_Body">
                                            </div>
                                        </ion-col>
                                    </ion-row>
                                </ion-card-content>
                            </ion-card>
                        </ion-col>
                    </ion-row>

                    <!-- Alteração de Estado da Candidatura -->
                    <ion-row class="email-template-section">
                        <ion-col size="12">
                            <ion-card>
                                <ion-card-header>
                                    <ion-card-title>Alteração de Estado da Candidatura</ion-card-title>
                                </ion-card-header>
                                <ion-card-content>
                                    <ion-row>
                                        <ion-col size="12"><strong>Assunto:</strong></ion-col>
                                        <ion-col size="12">{{
                                            item?.MerchantApplicationStatusChanged_Subject }}</ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col size="12"><strong>Corpo:</strong></ion-col>
                                        <ion-col size="12">
                                            <div class="email-body"
                                                [innerHTML]="item?.MerchantApplicationStatusChanged_Body">
                                            </div>
                                        </ion-col>
                                    </ion-row>
                                </ion-card-content>
                            </ion-card>
                        </ion-col>
                    </ion-row>

                    <!-- Nova Submissão de Candidatura -->
                    <ion-row class="email-template-section">
                        <ion-col size="12">
                            <ion-card>
                                <ion-card-header>
                                    <ion-card-title>Nova Submissão de Candidatura</ion-card-title>
                                </ion-card-header>
                                <ion-card-content>
                                    <ion-row>
                                        <ion-col size="12"><strong>Assunto:</strong></ion-col>
                                        <ion-col size="12">{{
                                            item?.NewMerchantApplicationSubmission_Subject }}</ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col size="12"><strong>Corpo:</strong></ion-col>
                                        <ion-col size="12">
                                            <div class="email-body"
                                                [innerHTML]="item?.NewMerchantApplicationSubmission_Body">
                                            </div>
                                        </ion-col>
                                    </ion-row>
                                </ion-card-content>
                            </ion-card>
                        </ion-col>
                    </ion-row>

                    <!-- Definir Password do Utilizador -->
                    <ion-row class="email-template-section">
                        <ion-col size="12">
                            <ion-card>
                                <ion-card-header>
                                    <ion-card-title>Definir Password do Utilizador</ion-card-title>
                                </ion-card-header>
                                <ion-card-content>
                                    <ion-row>
                                        <ion-col size="12"><strong>Assunto:</strong></ion-col>
                                        <ion-col size="12">{{ item?.DefineUserPassword_Subject
                                            }}</ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col size="12"><strong>Corpo:</strong></ion-col>
                                        <ion-col size="12">
                                            <div class="email-body" [innerHTML]="item?.DefineUserPassword_Body"></div>
                                        </ion-col>
                                    </ion-row>
                                </ion-card-content>
                            </ion-card>
                        </ion-col>
                    </ion-row>

                    <!-- Novo Registo de Utilizador -->
                    <ion-row class="email-template-section">
                        <ion-col size="12">
                            <ion-card>
                                <ion-card-header>
                                    <ion-card-title>Novo Registo de Utilizador</ion-card-title>
                                </ion-card-header>
                                <ion-card-content>
                                    <ion-row>
                                        <ion-col size="12"><strong>Assunto:</strong></ion-col>
                                        <ion-col size="12">{{ item?.NewUserRegist_Subject }}</ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col size="12"><strong>Corpo:</strong></ion-col>
                                        <ion-col size="12">
                                            <div class="email-body" [innerHTML]="item?.NewUserRegist_Body"></div>
                                        </ion-col>
                                    </ion-row>
                                </ion-card-content>
                            </ion-card>
                        </ion-col>
                    </ion-row>

                    <!-- Pedido de Código de Validação -->
                    <ion-row class="email-template-section">
                        <ion-col size="12">
                            <ion-card>
                                <ion-card-header>
                                    <ion-card-title>Pedido de Código de Validação</ion-card-title>
                                </ion-card-header>
                                <ion-card-content>
                                    <ion-row>
                                        <ion-col size="12"><strong>Assunto:</strong></ion-col>
                                        <ion-col size="12">{{ item?.UserValidationCodeRequest_Subject
                                            }}</ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col size="12"><strong>Corpo:</strong></ion-col>
                                        <ion-col size="12">
                                            <div class="email-body" [innerHTML]="item?.UserValidationCodeRequest_Body">
                                            </div>
                                        </ion-col>
                                    </ion-row>
                                </ion-card-content>
                            </ion-card>
                        </ion-col>
                    </ion-row>

                    <!-- Validação Automática de Utilizador -->
                    <ion-row class="email-template-section">
                        <ion-col size="12">
                            <ion-card>
                                <ion-card-header>
                                    <ion-card-title>Validação Automática de Utilizador</ion-card-title>
                                </ion-card-header>
                                <ion-card-content>
                                    <ion-row>
                                        <ion-col size="12"><strong>Assunto:</strong></ion-col>
                                        <ion-col size="12">{{ item?.UserAutomaticValidation_Subject
                                            }}</ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col size="12"><strong>Corpo:</strong></ion-col>
                                        <ion-col size="12">
                                            <div class="email-body" [innerHTML]="item?.UserAutomaticValidation_Body">
                                            </div>
                                        </ion-col>
                                    </ion-row>
                                </ion-card-content>
                            </ion-card>
                        </ion-col>
                    </ion-row>

                    <!-- Emissão de Cartão da Carteira -->
                    <ion-row class="email-template-section">
                        <ion-col size="12">
                            <ion-card>
                                <ion-card-header>
                                    <ion-card-title>Emissão de Cartão da Carteira</ion-card-title>
                                </ion-card-header>
                                <ion-card-content>
                                    <ion-row>
                                        <ion-col size="12"><strong>Assunto:</strong></ion-col>
                                        <ion-col size="12">{{ item?.IssueWalletCard_Subject }}</ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col size="12"><strong>Corpo:</strong></ion-col>
                                        <ion-col size="12">
                                            <div class="email-body" [innerHTML]="item?.IssueWalletCard_Body"></div>
                                        </ion-col>
                                    </ion-row>
                                </ion-card-content>
                            </ion-card>
                        </ion-col>
                    </ion-row>

                    <!-- Nova Notificação -->
                    <ion-row class="email-template-section">
                        <ion-col size="12">
                            <ion-card>
                                <ion-card-header>
                                    <ion-card-title>Nova Notificação</ion-card-title>
                                </ion-card-header>
                                <ion-card-content>
                                    <ion-row>
                                        <ion-col size="12"><strong>Assunto:</strong></ion-col>
                                        <ion-col size="12">{{ item?.NewNotification_Subject }}</ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col size="12"><strong>Corpo:</strong></ion-col>
                                        <ion-col size="12">
                                            <div class="email-body" [innerHTML]="item?.NewNotification_Body"></div>
                                        </ion-col>
                                    </ion-row>
                                </ion-card-content>
                            </ion-card>
                        </ion-col>
                    </ion-row>

                </ion-grid>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-col>